import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import SEO from "../utils/seo";

function Contact() {
  return (
    <>
      <section className="contact-page">
        <SEO
          title="MyDearCab - Top Cab Services in Pune"
          description="Book Pune to Mumbai cab at lowest fare. Clean cars, safe drivers, airport pickup & drop, 24/7 service. Sedan, SUV, Innova available. WhatsApp Booking: 8007722929."
          keywords="taxi service in pune,pune cab booking,pune airport cab service,pune airport pickup and drop,local taxi pune,online cab booking pune, pune to shirdi cab,pune to nashik cab,pune to aurangabad cab,pune to kolhapur cab,pune to goa cab,pune to mahabaleshwar cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai drop taxi,pune to mumbai car rental, pune to mumbai taxi lowest fare,pune to mumbai cab price,pune to mumbai cheap cab,pune to mumbai budget taxi,24 hours pune to mumbai cab,safe pune to mumbai cab for family,pune to mumbai airport drop cab,pune to mumbai sedan cab,pune to mumbai suv cab, pune airport to mumbai cab,hinjewadi to mumbai cab,swargate to mumbai cab,wakad to mumbai cab, pune to mumbai cab one way at affordable fare,pune to mumbai taxi service with driver,book pune to mumbai cab on whatsapp, pune to mumbai cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai one way taxi,pune to mumbai cab fare,pune to mumbai airport drop taxi,pune to mumbai online cab booking, Pune to Mumbai Cab | One Way Taxi | Lowest Fare | 24×7 Service, Near me cab service, Near me taxi service, Near me car rental services"
          canonicalUrl="https://www.mydearcab.com/contact"
        />
        <HeroPages name="Contact" />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2>Need additional information?</h2>
              <p>
                MyDearCab is your trusted transportation partner with over 8+
                years of experience in providing safe and reliable cab services.
                We pride ourselves on professional drivers, well-maintained
                vehicles, and excellent customer service.
              </p>
              <a href="tel:+918007722929">
                <i className="fa-solid fa-phone"></i>&nbsp; +91 8007722929
              </a>
              <a href="mailto:mydearcabs@gmail.com">
                <i className="fa-solid fa-envelope"></i>&nbsp;
                mydearcabs@gmail.com
              </a>
              <a href="https://maps.google.com">
                <i className="fa-solid fa-location-dot"></i>&nbsp; Pune,
                Maharashtra
              </a>
            </div>
            <div className="contact-div__form">
              <form>
                <label>
                  Full Name <b>*</b>
                </label>
                <input type="text" placeholder='E.g: "Joe Shmoe"'></input>

                <label>
                  Email <b>*</b>
                </label>
                <input type="email" placeholder="youremail@example.com"></input>

                <label>
                  Tell us about it <b>*</b>
                </label>
                <textarea placeholder="Write Here.."></textarea>

                <button type="submit">
                  <i className="fa-solid fa-envelope-open-text"></i>&nbsp; Send
                  Message
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a cab by getting in touch with MyDearCab</h2>
              <span>
                <i className="fa-solid fa-phone"></i>
                <h3>+91 8007722929</h3>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
